import { DeviceService } from '../../../services/device.service'
import ChangeDate from '@/components/ChangeDate.vue'
import _ from 'lodash'
export default {
  components: { ChangeDate },
  methods: {
    canApprove(status, managerIdInventory) {
      return (
        status === 'NEW' &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_IMPORT_APPROVE') &&
        this.dataUser.userId === managerIdInventory
      )
    },
    canReject(status, managerIdInventory) {
      return (
        status === 'NEW' &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_IMPORT_CHANGE_STATUS') &&
        this.dataUser.userId === managerIdInventory
      )
    },
    canCancel(status, userCreator, managerIdInventory) {
      return (
        status === 'NEW' &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_IMPORT_CHANGE_STATUS') &&
        (this.dataUser.userId === managerIdInventory ||
          this.dataUser.username === userCreator.email)
      )
    },
    canEdit(status, userCreator) {
      return (
        status === 'NEW' &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_IMPORT_UPDATE') &&
        this.dataUser.username === userCreator.email
      )
    },
    canCoppy(status, userCreator) {
      return (
        ['REJECTED', 'CANCELLED'].includes(status) && this.dataUser.username === userCreator.email
      )
    },
    canEditDate(status, userCreator) {
      return (
        ['APPROVED'].includes(status) &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_CHANGE_DATE_COMPLETE')
      )
    },
    async inTicket(id) {
      this.loading = true
      try {
        const res = await DeviceService.detailImportWarehouse(id)
        const data = res.data
        const devicesGroup = _.groupBy(res.data.devices, 'categoryName')
        data.devicesGroup = Object.values(devicesGroup)
        data.devicesTotalAmount = data.devices.reduce((t, i) => t + i.price, 0)
        await DeviceService.inImportTicket({ data })
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    detailItem(id) {
      const routeData = this.$router.resolve({
        path: `/import-warehouse/detail/${id}`,
      })
      window.open(routeData.href, '_blank')
    },
    approveItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn duyệt phiếu nhập ${item.billNumber} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.approveImportWarehouse({
              id: item.id,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Duyệt phiếu nhập ${item.billNumber} thành công`)
              this.fetchData()
            } else this.showErr(`Duyệt phiếu nhập ${item.billNumber} thất bại`)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    rejectItem(item) {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12' }),
      ])
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lý do từ chối',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.rejectImportWarehouse({
              id: item.id,
              reasonReject: this.$refs.rejectValue.value,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Từ chối phiếu nhập ${item.billNumber} thành công`)
              this.fetchData()
            } else {
              this.showErr(`Từ chối phiếu nhập ${item.billNumber} thất bại`)
            }
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancelItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn huỷ phiếu nhập ${item.billNumber} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.cancelImportWarehouse({
              id: item.id,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Huỷ phiếu nhập ${item.billNumber} thành công`)
              this.fetchData()
            } else this.showErr(`Huỷ phiếu nhập ${item.billNumber} thất bại`)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    editItem(id) {
      this.$router.push({
        path: `/import-warehouse/edit/${id}`,
      })
    },
    copyItem(coppyFrom) {
      this.$router.push({
        name: 'addImportWarehouse',
        params: { coppyFrom },
      })
    },
    editDate() {
      this.$bvModal.show('change-date')
    },
  },
}
